<template>
  <div class="el-section">
    <div
      class="emd-container _highlight_header _header_spaced _footer_spaced_sm"
    >
      <div class="emd-container__header">
        <h2 class="emd-text _size_section">
          {{ $t('plan.subscriptions.title') }}
        </h2>
      </div>
      <div
        v-if="loadingList"
        class="eu-pa_6 eu-align_center"
      >
        <emd-loader :type="'_invert'"></emd-loader>
      </div>
      <div
        v-else
        class="emd-table-responsive"
      >
        <Table
          :fields="fields"
          :items="subscriptions.items"
          :toDetail="permissionIsEnabled('subscription:get') && toDetail"
        ></Table>
        <empty-list
          v-if="showEmptyList()"
          entity="subscriptions"
        ></empty-list>
      </div>
      <pagination
        v-if="!loadingList"
        :pagination="subscriptions.pagination"
        :totalShowing="totalItems"
        :type="'list'"
        :action="action"
        :entity="'subscriptionId'"
      ></pagination>
    </div>
  </div>
</template>
<script>
import { EmdLoader } from 'emerald-vue/src/components'
import EmptyList from '@/components/project/globals/EmptyList.vue'
import Table from '@/components/project/molecules/Table.vue'
import Pagination from '@/components/project/globals/Pagination.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'PlanSubscriptions',
  components: {
    EmdLoader,
    EmptyList,
    Table,
    Pagination
  },
  data () {
    return {
      action: 'GET_SUBSCRIPTIONS',
      fields: [
        {
          id: 'id',
          label: 'plan.subscriptions.id',
          type: this.permissionIsEnabled('subscription:get') ? 'link' : 'text',
          link: {
            to: 'subscriptionsDetail',
            params: { id: 'id', tab: 'info' }
          }
        },
        {
          id: 'customer.name',
          label: 'plan.subscriptions.customer',
          type: 'text'
        },
        {
          id: 'status',
          label: 'plan.subscriptions.status',
          type: 'status'
        },
        {
          id: 'billing_type',
          label: 'plan.subscriptions.billing-type',
          type: 'text'
        },
        {
          id: 'interval',
          label: 'plan.subscriptions.interval',
          type: 'interval'
        },
        {
          id: 'created_at',
          label: 'plan.subscriptions.created-at',
          type: 'date',
          format: 'date'
        }
      ],
      toDetail: {
        name: 'subscriptionsDetail',
        params: {
          id: 'id',
          tab: 'info'
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'merchant',
      'account',
      'subscriptions',
      'loadingListSubscriptions'
    ]),
    loadingList () {
      return this.loadingListSubscriptions
    },
    totalItems () {
      return this.subscriptions.items.length
    }
  },
  methods: {
    showEmptyList () {
      return (
        !this.loadingList &&
        this.subscriptions.pagination &&
        this.subscriptions.pagination.total_items === 0
      )
    },
    permissionIsEnabled (action) {
      return this.$store.getters.permissionIsEnabled(action)
    }
  },
  beforeMount () {
    const query = { plan_id: this.$route.params.id }
    const params = {
      merchantId: this.merchant.id,
      accountId: this.account.id,
      query
    }
    this.$store.dispatch('GET_SUBSCRIPTIONS', params)
  }
}
</script>
